import { axiosInstance } from "./axios";
import { queryOptions } from "@tanstack/react-query";

export interface GameSummaryResponse {
    id: number;
    matchId: number;
    summary: string;
    model: string;
    tokensUsed: number;
    createdAt: string;
    updatedAt?: string;
    wasGenerated: boolean;
}

export interface GenerateGameSummaryRequest {
    gameId: number;
}

export const gameSummaryApi = {
    generateSummary: async (gameId: number): Promise<GameSummaryResponse> => {
        const response = await axiosInstance.post<GameSummaryResponse>(`/games/${gameId}/summary`);
        return response.data;
    },

    regenerateSummary: async (gameId: number): Promise<GameSummaryResponse> => {
        const response = await axiosInstance.put<GameSummaryResponse>(`/games/${gameId}/summary/regenerate`);
        return response.data;
    },

    getSummary: async (gameId: number, forceRegenerate: boolean = false): Promise<GameSummaryResponse> => {
        const response = await axiosInstance.get<GameSummaryResponse>(`/games/${gameId}/summary?forceRegenerate=${forceRegenerate}`);
        return response.data;
    },
};

export const gameSummaryQueryOptions = (matchId: number) =>
    queryOptions({
        queryKey: ["game-summary", matchId],
        queryFn: () => gameSummaryApi.getSummary(matchId),
        staleTime: 5 * 60 * 1000,
    });
